var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('div',{staticClass:"title-bar",staticStyle:{"background-color":"#212121"}},[_c('v-app-bar-nav-icon',{attrs:{"large":"","dark":""},on:{"click":function($event){return _vm.$emit('toggleDrawer')}}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }